import { render, staticRenderFns } from "./OrgStudent.vue?vue&type=template&id=5e9482f2&scoped=true"
import script from "./OrgStudent.vue?vue&type=script&lang=js"
export * from "./OrgStudent.vue?vue&type=script&lang=js"
import style0 from "./OrgStudent.vue?vue&type=style&index=0&id=5e9482f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9482f2",
  null
  
)

export default component.exports